import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import styles from './index.css';
import Header from './header';
import Article from './article';
import AllLook from './allLook';
import HotComment from './hotComment';
import RelateVideo from './relateVideo';
import RelateShortRecom from './relateShortRecom';
import BottomSlide from './bottomSlide';
import TwiceShare from './twiceShare';
import HouseRecommend from './houseRecommend';
import FixedIcon from '@ifeng-fe/container_content/common/client/fixedIcon';
import { callApp } from '@ifeng-fe/callapp';
import { h5PageCount, addBackGuide } from 'ThreeTerminal_utils';
import { WXGuideLayer } from 'ThreeTerminal_mobile_dynamic';
import { cookie } from '@ifeng-fe/ui_base';
import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';
import { unfoldTypeHanlde } from './articleFold';
import ShortCommentBottomAd from './shortCommentBottomAd';
import TvHall from './tvHall';
import { getParam } from '@src/utils/utils';
import { getBackUrl } from '@src/services/api';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        openCookieType: '',
    };

    gotoBackUrlHandle = async () => {
        const {
            content,
            content: { docData },
        } = this.props;
        const pageType = docData?.type === 'shortdoc' ? 'short' : 'article';
        const keywords = content?.keywords || '';
        const backUrl = await getBackUrl(keywords, pageType);

        addBackGuide(backUrl);
    };

    getOpenTypeHandle = () => {
        try {
            if (cookie.get('openCookieType')) {
                this.setState({
                    openCookieType: cookie.get('openCookieType').toString(),
                });
            } else {
                const randomNum = Math.floor(Math.random() * 3) + 1;

                cookie.set('openCookieType', randomNum);
                this.setState({
                    openCookieType: randomNum.toString(),
                });
            }
        } catch (e) {
            this.setState({
                openCookieType: '1',
            });
        }
    };

    setSupshotHandle = () => {
        const {
            content: { docData },
        } = this.props;
        const supshotType = getParam('supshot', location.search);

        if (supshotType === '1') {
           
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'supshot1',
                    other: {
                        id: `ucms_${docData.base62Id}`,
                    },
                },
            ]);
        }
        if (supshotType === '2') {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'supshot2',
                    other: {
                        id: `ucms_${docData.base62Id}`,
                    },
                },
            ]);
        }
        if (supshotType === '3') {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'supshot3',
                    other: {
                        id: `ucms_${docData.base62Id}`,
                    },
                },
            ]);
        }
    }

    componentDidMount() {
        this.setSupshotHandle();
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        const {
            content: { docData, unfold },
        } = this.props;
        let docType = docData.type;
        const pageUrl = location.href;
        const subscribe = docData?.subscribe || {};
        const isMedia = !!(!subscribe.forbidJump && subscribe.authorUrl);

        if (unfold.articleShareUnfold === '4') {
            if (new Date().getTime() < new Date('2023/12/22 20:00:00').getTime()) {
                this.getOpenTypeHandle();
            } else {
                this.setState({
                    openCookieType: '1',
                });
            }
        } else {
            this.setState({
                openCookieType: unfold.articleShareUnfold,
            });
        }

        // if (new Date().getTime() < new Date('2023/12/22 20:00:00').getTime() && unfold.articleShareUnfold === '4') {
        //     this.getOpenTypeHandle();
        // } else {
        //     this.setState({
        //         openCookieType: '1',
        //     });
        // }

        if (pageUrl.includes('from=oppowatch') && !navigator.userAgent.toLocaleLowerCase().includes('micromessenger')) {
            // oppowatch自动拉起
            h5PageCount([
                {
                    datatype: docData.isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'action',
                    type: 'fromwatch',
                    other: {
                        ref: `ucms_${docData.base62Id}`,
                        kind: 'article',
                    },
                },
            ]);
            callApp({
                client: docData.isVideoShare ? 'videoApp' : 'newsApp',
                docType: docData.type,
                pid: docData.base62Id,
                kind: 'brand_OPwc01',
                download: docData.isVideoShare
                    ? ''
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1470769136607',
                downloadAd: docData.isVideoShare
                    ? ''
                    : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8816',
            });
        }

        // 自媒体和非自媒体type值逻辑区分
        if (isMedia) {
            if (docType === 'article' || docType === 'doc') {
                docType = 'doc';
            } else if (docType === 'slide' || docType === 'slides' || docType === 'pic') {
                docType = 'slides';
            } else {
                docType = 'doc';
            }
        } else if (!isMedia) {
            if (docType === 'article' || docType === 'doc') {
                docType = 'article';
            } else if (docType === 'slide' || docType === 'slides' || docType === 'pic') {
                docType = 'pic';
            } else {
                docType = 'article';
            }
        }

        if (docData.type === 'short') {
            docType = 'shortdoc';
        }
        const userkeyValue = cookie.get('userkey');

        if (userkeyValue) {
            cookie.del('userkey', '/c/s');
        }
        const refValue = getParam('ref', location.search) || document.referrer;

        // 页面统计
        h5PageCount([
            {
                datatype: docData.isVideoShare ? 'vappsns_ex' : 'newsappsns',
                behavior: 'page',
                type: docType,
                other: {
                    id: `ucms_${docData.base62Id}`,
                    ref: encodeURIComponent(refValue),
                    url: encodeURIComponent(location.href),
                },
            },
        ]);

        this.gotoBackUrlHandle();
    }
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const {
            docData,
            headKeyword,
            subid,
            unfold,
            bigPicSwiperData,
            wutongData,
            keywords,
            safeLevel,
            isCloseAlgRec,
            activityOne,
            pageBottomPic,
            classV,
            commentTopAd,
            commentBottomAd,
            hasCopyRight,
            sourceReason,
            shortRecomAd,
            openMoreReadAd,
            recomVideoAd,
            bottomSlideAd,
            readNumConfig,
        } = content;
        const { openCookieType } = this.state;
        const houseSourceId =
            (docData.houseResourcesPlugin &&
                docData.houseResourcesPlugin[0] &&
                parseInt(docData.houseResourcesPlugin[0].id)) ||
            0;
        const houseRegionId =
            (docData.houseRegionPlugin && docData.houseRegionPlugin[0] && parseInt(docData.houseRegionPlugin[0].id)) ||
            0;
        const houseBulidId =
            (docData.housePropertyPlugin &&
                docData.housePropertyPlugin[0] &&
                parseInt(docData.housePropertyPlugin[0].id)) ||
            0;
        // const unfoldVal =
        //     (typeof document === 'object' && unfoldTypeHanlde(unfold.articleShareUnfold, unfold.regionFold)) || '1';
        const unfoldTextInfo = (unfold && unfold.articleShareUnfoldLayer) || {};
        const stopReadArticle = (unfold && unfold.stopReadArticle) || [];
        const wxLaunch = (unfold && unfold.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const wxConfig = (unfold && unfold.wxGuideLayer) || {};
        const wxGuideCallAppConfig = {
            client: docData.isVideoShare ? 'videoApp' : 'newsApp',
            docType: docData.type,
            pid: docData.base62Id,
            kind: 'share99',
            download: docData.isVideoShare
                ? ''
                : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1475599819841',
            downloadAd: docData.isVideoShare
                ? ''
                : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8826',
        };
        const wxGuideClickContinueConfig = {
            datatype: docData.isVideoShare ? 'vappsns_ex' : 'newsappsns',
            behavior: 'action',
            type: 'carryon',
            other: {
                ref: `ucms_${docData.base62Id}`,
                kind: 'other',
            },
        };
        const wxGuideClickCallAppConfig = {
            datatype: docData.isVideoShare ? 'vappsns_ex' : 'newsappsns',
            behavior: 'action',
            type: 'turnon',
            other: {
                ref: `ucms_${docData.base62Id}`,
                kind: 'other',
            },
        };
        const isHitBlack = safeLevel === 1;
        const ShortCommentBottomAdConfig = {
            skey: docData?.skey,
            commentUrl: docData?.commentUrl,
            ad: commentBottomAd,
        };

        return (
            <section className={styles.pageBody}>
                <img src={docData?.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg' } style={{ display: 'none' }} />
                {!isHitBlack && <TwiceShare content={docData} />}
                <Header content={docData} keyword={headKeyword} subid={subid} wxLaunch={wxLaunchConfig} />

                <Article
                    content={docData}
                    isHitBlack={isHitBlack}
                    unfoldType={openCookieType}
                    unfoldTextInfo={unfoldTextInfo}
                    stopReadArticle={stopReadArticle}
                    subid={subid}
                    wxLaunch={wxLaunchConfig}
                    searchPath={docData.searchPath}
                    activityOne={activityOne}
                    hasCopyRight={hasCopyRight}
                    sourceReason={sourceReason}
                    openMoreReadAd={openMoreReadAd}
                    readNumConfig={readNumConfig}
                />
                <NoSSR>
                    {docData.type !== 'short' && <Ad content={content.contentAd} />}
                    {docData.type !== 'short' && (
                        <HouseRecommend
                            houseSourceId={houseSourceId}
                            houseRegionId={houseRegionId}
                            houseBulidId={houseBulidId}
                        />
                    )}
                    {docData.type !== 'short' && (
                        <AllLook
                            content={docData}
                            ad={content.allLookAd}
                            bigPicSwiperData={bigPicSwiperData}
                            wutongData={wutongData}
                            wxLaunch={wxLaunchConfig}
                            isHitBlack={isHitBlack}
                            isCloseAlgRec={isCloseAlgRec}
                        />
                    )}
                    {!isHitBlack && docData.type !== 'short' && (
                        <RelateVideo
                            content={docData.base62Id}
                            isVideoShare={docData.isVideoShare}
                            title={docData.title}
                            ad={content.recommendVideoAd}
                            recomVideoAd={recomVideoAd}
                            wxLaunch={wxLaunchConfig}
                        />
                    )}
                    {!isHitBlack && docData.type === 'short' && <Ad content={commentTopAd} />}
                    <HotComment content={docData} subid={subid} wxLaunch={wxLaunchConfig} />
                    {!isHitBlack && docData.type !== 'short' && <TvHall isVideoShare={docData.isVideoShare} />}
                    {!isHitBlack && docData.type === 'short' && (
                        <ShortCommentBottomAd content={ShortCommentBottomAdConfig} />
                    )}
                    {!isHitBlack && docData.type === 'short' && (
                        <RelateShortRecom base62Id={docData.base62Id} wxLaunch={wxLaunchConfig} ad={shortRecomAd} />
                    )}
                    {!isHitBlack && (
                        <BottomSlide
                            content={docData}
                            wxLaunch={wxLaunchConfig}
                            pageBottomPic={pageBottomPic}
                            classV={classV}
                            config={content.fixedIcon.bottomSlide}
                            ad={bottomSlideAd}
                        />
                    )}
                    {!isHitBlack && (
                        <FixedIcon
                            type={content.fixedIcon.article}
                            link={content.fixedIcon.link}
                            image={content.fixedIcon.image}
                            clientLink={content.fixedIcon.clientLink}
                            pageType="artcile"
                            base62Id={docData.base62Id}
                            wxLaunch={wxLaunchConfig}
                        />
                    )}
                </NoSSR>

                <div className={styles.content_list}>
                    <Chip
                        id="200094"
                        type="struct"
                        title="小羊位配置维护"
                        groupName="小羊位配置维护"
                        translate="handleFixedIconData">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="285209" type="recommend" title="正文下海报维护项" groupName="正文下海报维护项">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="260185" type="struct" title="底部浮层海报维护项" groupName="底部浮层海报维护项">
                        <div className={styles.chip_item} />
                    </Chip>
                    <Chip id="260659" type="struct" title="阅读数维护项" groupName="阅读数维护项">
                        <div className={styles.chip_item} />
                    </Chip>
                </div>

                <ChipEdit transform={transform} />
                <WXGuideLayer
                    wxConfig={wxConfig}
                    base62Id={docData.base62Id}
                    callAppConfig={wxGuideCallAppConfig}
                    clickCallAppConfig={wxGuideClickCallAppConfig}
                    clickContinueConfig={wxGuideClickContinueConfig}
                    wxLaunchType={wxLaunchConfig.wxLaunchType}
                    wxLaunchSwitch={wxLaunchConfig.wxLaunchSwitch}
                />
            </section>
        );
    }
}

export default errorBoundary(Layout);
